import React from "react";
import { colors, socialProof } from "../config/site";

const SocialProof = () => {
  const items = socialProof.filter((i) => i.enabled);
  if (items.length === 0) return null;

  return (
    <section
      className="py-12 px-4 border-y"
      style={{ backgroundColor: colors.white, borderColor: "#E6DFD2" }}
      data-testid="social-proof-section"
    >
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-8">
          <p
            className="text-xs uppercase tracking-widest font-semibold"
            style={{ color: colors.terracotta }}
          >
            Our Impact
          </p>
        </div>
        <div
          className={`grid gap-6 ${
            items.length === 4
              ? "sm:grid-cols-2 lg:grid-cols-4"
              : items.length === 3
              ? "sm:grid-cols-3"
              : "sm:grid-cols-2"
          }`}
        >
          {items.map((stat, idx) => (
            <div
              key={stat.label}
              className="text-center rounded-2xl p-6 transition-transform hover:-translate-y-0.5"
              style={{
                backgroundColor: idx % 2 === 0 ? colors.cream : colors.ivory,
                borderTop: `3px solid ${
                  [colors.primary, colors.terracotta, colors.sage, colors.gold][idx % 4]
                }`,
              }}
              data-testid={`social-proof-stat-${idx}`}
            >
              <p
                className="text-3xl lg:text-4xl font-bold mb-1 leading-none"
                style={{
                  color: [colors.primary, colors.terracotta, colors.sage, colors.terracottaDark][
                    idx % 4
                  ],
                }}
              >
                {stat.value}
              </p>
              <p
                className="text-xs uppercase tracking-wider font-semibold"
                style={{ color: colors.textMuted }}
              >
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
